import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import WeatherCard from './components/WeatherCard';
import CitySearch from './components/CitySearch';
import WeatherBackground from './components/WeatherBackground';
import { philippineCities } from './data/cities';
import { getWeatherData } from './services/weatherService';

function App() {
  const [selectedCity, setSelectedCity] = useState('Manila');
  const [weatherData, setWeatherData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchWeatherData(selectedCity);
  }, [selectedCity]);

  const fetchWeatherData = async (city) => {
    setLoading(true);
    setError(null);
    try {
      const data = await getWeatherData(city);
      setWeatherData(data);
    } catch (err) {
      setError('Failed to fetch weather data');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen relative overflow-hidden">
      <WeatherBackground weatherData={weatherData} />
      
      <div className="relative z-10 container mx-auto px-4 py-8">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-8"
        >
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-2 drop-shadow-lg">
            Philippine Weather
          </h1>
          <p className="text-xl text-white/90 drop-shadow-md">
            Real-time weather updates across the Philippines
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="max-w-md mx-auto mb-8"
        >
          <CitySearch
            cities={philippineCities}
            selectedCity={selectedCity}
            onCitySelect={setSelectedCity}
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="max-w-2xl mx-auto"
        >
          <WeatherCard
            weatherData={weatherData}
            loading={loading}
            error={error}
            city={selectedCity}
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="mt-12 text-center"
        >
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto">
            {philippineCities.slice(0, 8).map((city, index) => (
              <button
                key={city}
                onClick={() => setSelectedCity(city)}
                className={`p-3 rounded-lg backdrop-blur-sm transition-all duration-300 ${
                  selectedCity === city
                    ? 'bg-white/30 text-white border-2 border-white/50'
                    : 'bg-white/10 text-white/80 hover:bg-white/20 border-2 border-transparent'
                }`}
              >
                {city}
              </button>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  );
}

export default App;